import React, { useState, useRef } from "react";
import config from "../config";
import { useTranslation } from "react-i18next";

const CyberSourceCheckout = ({ subscription }) => {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState(null);
  const {t} = useTranslation();

  const handlePayment = async () => {
    setLoading(true);
    setError(null);
   
    localStorage.setItem("mySubscription", JSON.stringify(subscription));
    try {
      let totalAmount = subscription.subscription_cost;

      if (subscription?.coupon) {
        const discount = subscription.coupon.discount_value;
        if (subscription.coupon.discount_type === "percentage") {
          totalAmount = subscription.subscription_cost * (1 - discount / 100);
        } else {
          totalAmount = subscription.subscription_cost - discount;
        }
      }
  // transaction_type: "sale,create_payment_token",
      // Ensure it's not negative
      totalAmount = Math.max(0, totalAmount);
      const res = await fetch(`${config.apiUrl}/generate-signature`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          transaction_type: "sale,create_payment_token", // Changed from 'sale' to 'authorization'
          reference_number: `${subscription.subscription_id}-${
            subscription.client_id
          }-${subscription.client_subscription_id}-${Date.now()}`,
          amount: totalAmount,
          currency: "QAR",
        }),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      console.log("Received data:", data);

      // Store form data for debugging
      setFormData(data);

      const form = formRef.current;

      // Clear any existing hidden inputs
      const existingInputs = form.querySelectorAll('input[type="hidden"]');
      existingInputs.forEach((input) => input.remove());

      // Add all fields as hidden inputs
      Object.keys(data).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      });

      // Submit the form
      form.submit();
    } catch (err) {
      console.error("Error preparing CyberSource form:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  //https://testsecureacceptance.cybersource.com/pay
  //https://secureacceptance.cybersource.com/pay
  return (
    <div className="p-4">
      <form
        ref={formRef}
        method="post"
        action="https://secureacceptance.cybersource.com/pay"
      >
        <button
          type="button"
          onClick={handlePayment}
          disabled={loading}
          className="flex items-center justify-center w-full  gap-2 py-2 px-4 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="18.4466 -44.2328 512 332.8"
            className="w-8 h-8"
          >
            <path
              style={{ strokeWidth: 1, fill: "rgb(134, 182, 243)" }}
              d="M 576.076 302.21 L 140.876 302.21 C 119.756 302.21 102.476 284.93 102.476 263.81 L 102.476 7.81 C 102.476 -13.31 119.756 -30.59 140.876 -30.59 L 576.076 -30.59 C 597.196 -30.59 614.476 -13.31 614.476 7.81 L 614.476 263.81 C 614.476 284.93 597.196 302.21 576.076 302.21 Z"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <path
              style={{ strokeWidth: 1, fill: "rgb(90, 90, 188)" }}
              d="M 576.076 -30.59 L 512.076 -30.59 C 533.196 -30.59 550.476 -13.31 550.476 7.81 L 550.476 263.81 C 550.476 284.93 533.196 302.21 512.076 302.21 L 576.076 302.21 C 597.196 302.21 614.476 284.93 614.476 263.81 L 614.476 7.81 C 614.476 -13.31 597.196 -30.59 576.076 -30.59 Z"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <rect
              y="46.21"
              style={{ strokeWidth: 1, fill: "rgb(85, 85, 86)" }}
              width="512"
              height="76.8"
              x="102.476"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <rect
              x="550.476"
              y="46.21"
              style={{ strokeWidth: 1, fill: "rgb(59, 57, 62)" }}
              width="64"
              height="76.8"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <circle
              style={{ fill: "rgb(224, 113, 136)", strokeWidth: 1 }}
              cx="192.076"
              cy="212.61"
              r="38.4"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <circle
              style={{ fill: "rgb(248, 233, 155)", strokeWidth: 1 }}
              cx="243.276"
              cy="212.61"
              r="38.4"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <path
              style={{ fill: "rgb(136, 136, 143)", strokeWidth: 1 }}
              d="M 540.876 196.61 L 336.076 196.61 C 330.774 196.61 326.476 192.313 326.476 187.01 C 326.476 181.707 330.774 177.41 336.076 177.41 L 540.876 177.41 C 546.179 177.41 550.476 181.707 550.476 187.01 C 550.476 192.313 546.179 196.61 540.876 196.61 Z"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <path
              style={{ fill: "rgb(136, 136, 143)", strokeWidth: 1 }}
              d="M 515.276 235.01 L 336.076 235.01 C 330.774 235.01 326.476 230.713 326.476 225.41 C 326.476 220.107 330.774 215.81 336.076 215.81 L 515.276 215.81 C 520.579 215.81 524.876 220.107 524.876 225.41 C 524.876 230.713 520.579 235.01 515.276 235.01 Z"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            />
            <text
              style={{
                fill: "rgb(242, 241, 249)",
                fontFamily: "Arial, sans-serif",
                fontSize: "28px",
                whiteSpace: "pre",
              }}
              x="185.029"
              y="90.027"
              transform="matrix(1, 0, 0, 1, -84.02937316894528, -13.64278507232666)"
            >
              CREDIT CARD
            </text>
          </svg>
          {loading ? "Processing..." : t("pay")}
        </button>
      </form>

      {error && (
        <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          Error: {error}
        </div>
      )}
    </div>
  );
};

export default CyberSourceCheckout;
